import Alpine from 'alpinejs'
import data from '../cities.json'

document.addEventListener('alpine:init', () => {
  Alpine.data('CitySlug', ({ name, base }: { name: string; base: string }) => ({
    cityUrlString: '',
    cityName: name,

    init() {
      const cityByName = data.cities.find((item) => item.name === this.cityName)
      const urlString = base + cityByName?.slug
      return (this.cityUrlString = urlString)
    },
  }))
})
